import React from "react";
import PaymentReceipt from "./PaymentReceipt";
import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const PaymentDetailsModal = ({ payment, onClose }) => {
  if (!payment) return null;

  // تحديد لون حالة الدفع
  const getStatusBadge = () => {
    if (payment.status === "completed") {
      return (
        <span className="px-3 py-1 rounded-full bg-green-100 text-green-800 text-sm font-medium">
          مكتمل
        </span>
      );
    } else {
      return (
        <span className="px-3 py-1 rounded-full bg-yellow-100 text-yellow-800 text-sm font-medium">
          معلق
        </span>
      );
    }
  };

  // تحديد نوع المدفوعات
  const getPaymentType = () => {
    switch (payment.type) {
      case "case":
        return (
          <span className="px-3 py-1 rounded-md bg-blue-100 text-blue-800 text-sm font-medium">
            قضية
          </span>
        );
      case "consultation":
        return (
          <span className="px-3 py-1 rounded-md bg-purple-100 text-purple-800 text-sm font-medium">
            استشارة
          </span>
        );
      default:
        return (
          <span className="px-3 py-1 rounded-md bg-gray-100 text-gray-800 text-sm font-medium">
            أخرى
          </span>
        );
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-xl overflow-hidden">
        {/* رأس المودل */}
        <div className="bg-gradient-to-l from-blue-600 to-blue-800 text-white p-4 flex justify-between items-center">
          <div className="flex items-center">
            <svg
              className="w-6 h-6 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2z"
              />
            </svg>
            <h3 className="text-xl font-bold">تفاصيل المدفوع</h3>
          </div>
          <button
            onClick={onClose}
            className="text-white hover:text-gray-200 focus:outline-none"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* محتوى المودل */}
        <div className="p-6">
          {/* المعلومات الرئيسية */}
          <div className="flex justify-between items-start mb-6">
            <div>
              <div className="text-gray-500 text-sm mb-1">رقم الإيصال</div>
              <div className="text-lg font-bold text-blue-700">
                #{payment.id}
              </div>
            </div>
            <div className="text-left">
              <div className="text-gray-500 text-sm mb-1">الحالة</div>
              <div>{getStatusBadge()}</div>
            </div>
          </div>

          {/* معلومات المبلغ */}
          <div className="bg-blue-50 p-4 rounded-lg mb-6">
            <div className="text-center">
              <div className="text-sm text-blue-600 mb-1">المبلغ</div>
              <div className="text-2xl font-bold text-blue-700">
                {payment.amount} دينار
              </div>
            </div>
          </div>

          {/* تفاصيل العميل والقضية */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <h4 className="font-medium text-gray-700 mb-3 border-b pb-2">
              معلومات العميل والقضية
            </h4>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-gray-500 text-sm">العميل</p>
                <p className="font-medium">
                  {payment.client_name || "غير محدد"}
                </p>
              </div>
              <div>
                <p className="text-gray-500 text-sm">رقم القضية</p>
                <p className="font-medium">
                  {payment.case_number || "غير محدد"}
                </p>
              </div>
              <div>
                <p className="text-gray-500 text-sm">التاريخ</p>
                <p className="font-medium">
                  {new Date(payment.date).toLocaleDateString("ar-EG")}
                </p>
              </div>
              <div>
                <p className="text-gray-500 text-sm">النوع</p>
                <p className="font-medium">{getPaymentType()}</p>
              </div>
            </div>
          </div>

          {/* الوصف */}
          {payment.description && (
            <div className="mb-6">
              <h4 className="font-medium text-gray-700 mb-2">الوصف</h4>
              <p className="bg-gray-50 p-3 rounded-lg text-gray-700">
                {payment.description}
              </p>
            </div>
          )}
        </div>

        {/* زر الطباعة */}
        <div className="border-t py-4 px-6 bg-gray-50 flex justify-end items-center">
          <div className="flex space-x-3 space-x-reverse">
            <PaymentReceipt
              payment={payment}
              showLabel={true}
              className="px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded-md flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
            />
            <Button
              type="default"
              icon={<CloseOutlined style={{ fontSize: "1rem" }} />}
              onClick={onClose}
              className="border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100 flex items-center gap-2"
              title="إغلاق"
            >
              إغلاق
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetailsModal;
